//
// Copyright 2022 DXOS.org
//

import * as path from 'path-browserify';

export {
  basename,
  dirname,
  extname,
  format,
  isAbsolute,
  join,
  normalize,
  parse,
  relative,
  resolve,
} from 'path-browserify';
export default path;
